var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "address__input-group-wrapper" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-4 col-md-2" }, [
        _c(
          "div",
          {
            staticClass: "js--validate-input",
            attrs: { "data-model": "addressSalutation", "data-validate": "" },
          },
          [
            _c("salutation-select", {
              attrs: {
                "address-type": _vm.addressType,
                "address-data": _vm.value,
                "enabled-address-fields": _vm.optionalAddressFields,
              },
              on: {
                input: function ($event) {
                  return _vm.emitInputEvent($event.field, $event.value)
                },
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-12 col-xs-sm--m-t-16 col-md-5" }, [
        _c(
          "div",
          {
            staticClass: "input__wrapper",
            attrs: { "data-validate": "text", "data-model": "name2" },
          },
          [
            _c("input", {
              attrs: {
                type: "text",
                name: "firstName",
                title: _vm.$translate("Ceres::Template.addressFirstName"),
                placeholder: _vm.$translate("Ceres::Template.addressFirstName"),
                id: "txtFirstName" + _vm._uid,
              },
              domProps: { value: _vm.value.name2 },
              on: {
                input: function ($event) {
                  return _vm.emitInputEvent("name2", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _c("label", { attrs: { for: "txtFirstName" + _vm._uid } }, [
              _vm._v(
                "\n                    " +
                  _vm._s(_vm.$translate("Ceres::Template.addressFirstName")) +
                  "*\n                "
              ),
            ]),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-12 col-xs-sm--m-t-16 col-md-5" }, [
        _c(
          "div",
          {
            staticClass: "input__wrapper",
            attrs: { "data-validate": "text", "data-model": "name3" },
          },
          [
            _c("input", {
              attrs: {
                type: "text",
                name: "lastName",
                title: _vm.$translate("Ceres::Template.addressLastName"),
                placeholder: _vm.$translate("Ceres::Template.addressLastName"),
                id: "txtLastName" + _vm._uid,
              },
              domProps: { value: _vm.value.name3 },
              on: {
                input: function ($event) {
                  return _vm.emitInputEvent("name3", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _c("label", { attrs: { for: "txtLastName" + _vm._uid } }, [
              _vm._v(
                "\n                    " +
                  _vm._s(_vm.$translate("Ceres::Template.addressLastName")) +
                  "*\n                "
              ),
            ]),
          ]
        ),
      ]),
    ]),
    _vm._v(" "),
    _vm.value.gender === "company"
      ? _c("div", { staticClass: "row row--m-t-16" }, [
          _c("div", { staticClass: "col-12 col-md-6" }, [
            _c(
              "div",
              {
                staticClass: "input__wrapper",
                attrs: { "data-model": "name1" },
              },
              [
                _c("input", {
                  attrs: {
                    type: "text",
                    name: "company",
                    title: _vm.$translate("Ceres::Template.addressCompany"),
                    placeholder: _vm.$translate(
                      "Ceres::Template.addressCompany"
                    ),
                    id: "txtCompany" + _vm._uid,
                  },
                  domProps: { value: _vm.value.name1 },
                  on: {
                    input: function ($event) {
                      return _vm.emitInputEvent("name1", $event.target.value)
                    },
                  },
                }),
                _vm._v(" "),
                _c("label", { attrs: { for: "txtCompany" + _vm._uid } }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$translate("Ceres::Template.addressCompany")) +
                      "\n                "
                  ),
                ]),
              ]
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-12 col-xs-sm--m-t-16 col-md-6" },
            [
              _c("vat-id", {
                attrs: {
                  "is-required": _vm.isInRequiredFields(
                    "de",
                    "billing_address.vatNumber"
                  ),
                  "selected-country-id": _vm.value.countryId,
                  value: _vm.value.vatNumber || "",
                  "show-input":
                    (_vm.isInOptionalFields(
                      "de",
                      "billing_address.salutation"
                    ) &&
                      _vm.value.gender === "company" &&
                      _vm.isInOptionalFields(
                        "de",
                        "billing_address.vatNumber"
                      )) ||
                    (!_vm.isInOptionalFields(
                      "de",
                      "billing_address.salutation"
                    ) &&
                      _vm.isInOptionalFields("de", "billing_address.name1") &&
                      _vm.isInOptionalFields(
                        "de",
                        "billing_address.vatNumber"
                      )),
                },
                on: {
                  input: function ($event) {
                    return _vm.emitInputEvent("vatNumber", $event)
                  },
                },
              }),
            ],
            1
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "row row--m-t-16" }, [
      _c("div", { staticClass: "col-9 col-md-6" }, [
        _c(
          "div",
          {
            staticClass: "input__wrapper",
            attrs: { "data-validate": "text", "data-model": "address1" },
          },
          [
            _c("input", {
              attrs: {
                type: "text",
                name: "street",
                title: _vm.$translate("Ceres::Template.addressStreet"),
                placeholder: _vm.$translate("Ceres::Template.addressStreet"),
                id: "txtStreet" + _vm._uid,
              },
              domProps: { value: _vm.value.address1 },
              on: {
                input: function ($event) {
                  return _vm.emitInputEvent("address1", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _c("label", { attrs: { for: "txtStreet" + _vm._uid } }, [
              _vm._v(
                "\n                    " +
                  _vm._s(_vm.$translate("Ceres::Template.addressStreet")) +
                  "*\n                "
              ),
            ]),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-3 col-md-1" }, [
        _c(
          "div",
          {
            staticClass: "input__wrapper",
            attrs: { "data-validate": "text", "data-model": "address2" },
          },
          [
            _c("input", {
              attrs: {
                type: "text",
                name: "housenumber",
                title: _vm.$translate("Ceres::Template.addressNumber"),
                placeholder: _vm.$translate("Ceres::Template.addressNumber"),
                id: "txtNumber" + _vm._uid,
              },
              domProps: { value: _vm.value.address2 },
              on: {
                input: function ($event) {
                  return _vm.emitInputEvent("address2", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _c("label", { attrs: { for: "txtNumber" + _vm._uid } }, [
              _vm._v(
                "\n                    " +
                  _vm._s(_vm.$translate("Ceres::Template.addressNumber")) +
                  "*\n                "
              ),
            ]),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-12 col-xs-sm--m-t-16 col-md-5" }, [
        _c(
          "div",
          {
            staticClass: "input__wrapper",
            attrs: { "data-model": "address3" },
          },
          [
            _c("input", {
              attrs: {
                type: "text",
                name: "decorateAddress",
                title: _vm.$translate(
                  "ODFashioncode::Fashioncode.checkoutAddressAdditional"
                ),
                placeholder: _vm.$translate(
                  "ODFashioncode::Fashioncode.checkoutAddressAdditional"
                ),
                id: "decorateAddress0" + _vm._uid,
              },
              domProps: { value: _vm.value.address3 },
              on: {
                input: function ($event) {
                  return _vm.emitInputEvent("address3", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _c("label", { attrs: { for: "decorateAddress0" + _vm._uid } }, [
              _vm._v(
                "\n                    " +
                  _vm._s(
                    _vm.$translate(
                      "ODFashioncode::Fashioncode.checkoutAddressAdditional"
                    )
                  ) +
                  "\n                "
              ),
            ]),
          ]
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row row--m-t-16" }, [
      _c("div", { staticClass: "col-4 col-md-2" }, [
        _c(
          "div",
          {
            staticClass: "input__wrapper",
            attrs: { "data-validate": "text", "data-model": "postalCode" },
          },
          [
            _c("input", {
              attrs: {
                type: "text",
                name: "zip",
                title: _vm.$translate("Ceres::Template.addressZip"),
                placeholder: _vm.$translate("Ceres::Template.addressZip"),
                id: "txtZip" + _vm._uid,
              },
              domProps: { value: _vm.value.postalCode },
              on: {
                input: function ($event) {
                  return _vm.emitInputEvent("postalCode", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _c("label", { attrs: { for: "txtZip" + _vm._uid } }, [
              _vm._v(
                "\n                    " +
                  _vm._s(_vm.$translate("Ceres::Template.addressZip")) +
                  "*\n                "
              ),
            ]),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-8 col-md-4" }, [
        _c(
          "div",
          {
            staticClass: "input__wrapper",
            attrs: { "data-validate": "text", "data-model": "town" },
          },
          [
            _c("input", {
              attrs: {
                type: "text",
                name: "town",
                title: _vm.$translate("Ceres::Template.addressPlace"),
                placeholder: _vm.$translate("Ceres::Template.addressPlace"),
                id: "txtPlace" + _vm._uid,
              },
              domProps: { value: _vm.value.town },
              on: {
                input: function ($event) {
                  return _vm.emitInputEvent("town", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _c("label", { attrs: { for: "txtPlace" + _vm._uid } }, [
              _vm._v(
                "\n                    " +
                  _vm._s(_vm.$translate("Ceres::Template.addressPlace")) +
                  "*\n                "
              ),
            ]),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-12 col-xs-sm--m-t-16 col-md-6" }, [
        _c(
          "div",
          {
            staticClass: "js--validate-input",
            attrs: { "data-model": "countryId", "data-validate": "" },
          },
          [
            _c("country-select", {
              attrs: {
                "selected-country-id": _vm.value.countryId,
                "selected-state-id": _vm.value.stateId,
                "address-type": _vm.addressType,
                "optional-address-fields": _vm.optionalAddressFields,
                "required-address-fields": _vm.requiredAddressFields,
              },
              on: {
                "country-changed": function ($event) {
                  return _vm.onSelectedCountryChanged($event)
                },
                "state-changed": function ($event) {
                  return _vm.emitInputEvent("stateId", $event)
                },
              },
            }),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }